import { css } from '@flipster/styled-system/css';
import { divider } from '@flipster/styled-system/patterns';

export const closedColorCssRaw = css.raw({ color: 'content.default.level-2' });

export const layoutCssRaw = css.raw({
  textStyle: 'Text/M/Regular',
  color: 'content.default.level-3',
  '& dt': { textAlign: 'left', color: 'content.default.level-3' },
  '& dd': { textAlign: 'right', color: 'content.default.level-5' },
  '&.closed, &.closed dt, &.closed dd': closedColorCssRaw,
});

export const dlCssRaw = css.raw({
  '& > div': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  '& > div + div': { pt: 8 },
});

export const currencyCssRaw = closedColorCssRaw;

export const dividerCssRaw = divider.raw({ orientation: 'horizontal', color: 'border.default.level-1', my: 4 });
